module.exports = __webpack_public_path__ + "img/main-11.88c26380.jpg";